import React from 'react';
import cx from 'classnames';
import rehypeRaw from 'rehype-raw';
import Markdown from 'react-markdown';

import SmartLink from '../SmartLink';

import { Body1, ButtonText, Heading4, Tag } from '../Typography';
import { ReactComponent as ArrowRight } from '../../assets/svg/arrow-forward.svg';

import styles from './index.module.scss';

export enum BackgroundColor {
  GRADIENT = 'gradient',
  RED = 'red',
  GREEN = 'green',
  WHITE = 'white',
}

const BackgroundColorMap: Record<BackgroundColor, string> = {
  [BackgroundColor.GRADIENT]:
    'linear-gradient(90deg, rgba(85, 68, 148, 1) 0%, rgba(255, 97, 69, 1) 100%)',
  [BackgroundColor.RED]: '#c8585f',
  [BackgroundColor.GREEN]: '#7C9179',
  [BackgroundColor.WHITE]: '#FFFFFF',
};

export interface TextBannerLargeProps {
  url?: string;
  eyebrow?: string;
  title: string;
  text?: string;
  buttonText?: string;
  buttonUrl?: string;
  backgroundColor?: BackgroundColor;
}

const TextBannerLarge: React.FC<TextBannerLargeProps> = ({
  url,
  eyebrow,
  title,
  text,
  buttonText,
  buttonUrl,
  backgroundColor = BackgroundColor.RED,
}) => {
  const backgroundColorValue = BackgroundColorMap[backgroundColor];
  const isBackgroundWhite = backgroundColor === BackgroundColor.WHITE;

  const content = () => {
    return (
      <>
        {eyebrow && (
          <div className={styles.header}>
            <Tag className={styles.eyebrow}>{eyebrow}</Tag>
            {url && <ArrowRight />}
          </div>
        )}

        <Heading4>{title}</Heading4>
        {text && (
          <Body1 element='div' className={styles.text}>
            <Markdown rehypePlugins={[rehypeRaw]}>{text}</Markdown>
          </Body1>
        )}

        {buttonText && buttonUrl && (
          <SmartLink to={buttonUrl} className={styles.button}>
            <ButtonText>{buttonText}</ButtonText>
          </SmartLink>
        )}
      </>
    );
  };

  return (
    <>
      {url ? (
        <SmartLink
          to={url}
          className={cx(styles.wrapper, styles.link, {
            [styles.textBlack]: isBackgroundWhite,
          })}
          style={{ background: backgroundColorValue }}
        >
          {content()}
        </SmartLink>
      ) : (
        <div
          className={cx(styles.wrapper, {
            [styles.textBlack]: isBackgroundWhite,
          })}
          style={{ background: backgroundColorValue }}
        >
          {content()}
        </div>
      )}
    </>
  );
};

export default TextBannerLarge;
